module.exports = __webpack_public_path__ + "img/coin_present_arrow.c588ad47.svg";